<template>
  <div class="index" v-loading="loading">
    <div class="stats">
      <el-row style="display: flex; align-items: center; margin-bottom: 20px">
        <span style="font-weight: 600; color: #2080ee"
          >当前在线人数：<span style="font-weight: 600; color: #67c23a"
            >{{ onlineNum }}<i class="el-icon-s-custom"></i></span
        ></span>
      </el-row>
      <el-row style="display: flex; align-items: center; margin-bottom: 20px">
        <el-switch
          v-model="webStatus"
          :active-value="true"
          :inactive-value="false"
          active-text="网站开启"
          inactive-text="网站拉闸"
          active-color="#67C23A"
          inactive-color="#F56C6C"
          @change="changeWebStatus"
        ></el-switch>
      </el-row>
      <el-row>
        <el-col :span="2">
          <el-input v-model="params.id" placeholder="请输入用户id"></el-input>
        </el-col>
        <el-col style="width: 200px; margin-right: 20px">
          <el-date-picker
            v-model="params.start_time"
            type="datetime"
            placeholder="开始日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-col>
        <el-col style="width: 200px; margin-right: 20px">
          <el-date-picker
            v-model="params.end_time"
            type="datetime"
            placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: auto"
          >
          </el-date-picker>
        </el-col>
        <el-button type="primary" @click="getStatsData">查询</el-button>
        <el-button type="primary" @click="handleExport"
          >24小时掉落饰品</el-button
        >
        <el-button type="primary" @click="gameRanking">对战排行</el-button>
        <el-button type="primary" @click="profitCache" :loading="bottonLoading"
          >利润缓存</el-button
        >
        <el-button type="primary" @click="exportKnapsack">导出背包</el-button>
      </el-row>
      <p class="prompt">默认展示当天数据</p>
      <el-row :gutter="20" v-if="statsData">
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>新注册</span></div>
              <div class="text item">{{ statsData.register_num }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>充值金额</span></div>
              <div class="text item">{{ statsData.recharge_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>CDK充值金额</span></div>
              <div class="text item">{{ statsData.recharge_cdk_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>有效注册人数</span>
              </div>
              <div class="text item">{{statsData.register_nums}}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>有效注册充值</span>
              </div>
              <div class="text item">{{statsData.register_recharge}}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>当日有效充值人数</span>
              </div>
              <div class="text item">{{statsData.register_true_recharge}}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>待处理</span></div>
              <div class="text item">{{ statsData.wait_get_out_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>通过金额</span></div>
              <div class="text item">{{ statsData.passed_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <!-- <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>ROLL金额</span></div>
              <div class="text item">{{ statsData.trade_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>ROLL金额2</span></div>
              <div class="text item">{{ statsData.trade_recycle_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>签到金额</span></div>
              <div class="text item">{{ statsData.check_in_amount }}</div>
            </el-card>
          </div>
        </el-col> -->
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>返利金额</span></div>
              <div class="text item">{{ statsData.rebate_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>渠道金额</span></div>
              <div class="text item">{{ statsData.anchor_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>抽奖次数</span></div>
              <div class="text item">{{ statsData.lottery_times }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>抽奖金额</span></div>
              <div class="text item">{{ statsData.lottery_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>背包金额(普通用户)</span>
              </div>
              <div class="text item">{{ statsData.lottery_normal_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <!-- <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>背包金额2</span></div>
              <div class="text item">
                {{ statsData.lottery_recycle_amount }}
              </div>
            </el-card>
          </div>
        </el-col> -->
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>奖品金额</span></div>
              <div class="text item">{{ statsData.prize_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>出售金额</span></div>
              <div class="text item">{{ statsData.sell_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <!-- <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>普通未通过金额</span>
              </div>
              <div class="text item">
                {{ statsData.manual_delivery_amount }}
              </div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>普通处理通过金额</span>
              </div>
              <div class="text item">{{ statsData.manual_pass_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货中金额</span>
              </div>
              <div class="text item">{{ statsData.zbt_delivery_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货失败金额</span>
              </div>
              <div class="text item">{{ statsData.zbt_fail_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货成功金额</span>
              </div>
              <div class="text item">{{ statsData.zbtSuccessAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单等待发货金额</span>
              </div>
              <div class="text item">{{ statsData.zbtTakeOverAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货中金额(T)</span>
              </div>
              <div class="text item">{{ statsData.zbtTDeliveryAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货失败金额(T)</span>
              </div>
              <div class="text item">{{ statsData.zbtTFailAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单发货成功金额(T)</span>
              </div>
              <div class="text item">{{ statsData.zbtTSuccessAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>ZBT订单等待发货金额(T)</span>
              </div>
              <div class="text item">{{ statsData.zbtTTakeOverAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>机器订单发货中金额</span>
              </div>
              <div class="text item">{{ statsData.robot_delivery_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>机器人订单完成金额</span>
              </div>
              <div class="text item">{{ statsData.robot_pass_amount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix"><span>利润</span></div>
              <div class="text item">{{ statsData.profits }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>商城交易成功金额</span>
              </div>
              <div class="text item">{{ statsData.shop_prize_amount }}</div>
            </el-card>
          </div>
        </el-col> -->
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>拉新红包金额统计</span>
              </div>
              <div class="text item">{{ statsData.shareRedAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>福利红包领取统计</span>
              </div>
              <div class="text item">{{ statsData.welfareRedAmount }}</div>
            </el-card>
          </div>
        </el-col>
        <!-- <el-col :xs="8" :sm="6" :md="4" :lg="3">
          <div class="grid-content bg-purple">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>进行中roll房金额</span>
              </div>
              <div class="text item">{{ statsData.room_amount }}</div>
            </el-card>
          </div>
        </el-col> -->
      </el-row>
    </div>
  </div>
</template>

<script>
import http, { getApiData, patchApiData, postApiData, server, api } from '../../http'

export default {
  data() {
    return {
      loading: false,
      bottonLoading: false,//按钮动画
      webStatus: true,//网站开启或关闭状态
      statsData: undefined,
      onlineNum: '',//当前在线总人数
      params: {
        id: undefined,
        start_time: undefined,
        end_time: undefined
      }
    }
  },
  created() {
    this.getOnlineNum()//获取当前在线人数
    this.getWebStatus()//获取官网网站状态
    this.getStatsData()//拿取总览数据
  },
  methods: {
    getOnlineNum() {
      // 获取当前在线人数
      getApiData('onlineNum')
        .then(res => {
          this.onlineNum = res
        })
    },
    getWebStatus() {
      //获取官网网站状态
      getApiData('get_all_config')
        .then(res => {
          this.webStatus = res.data
        })
    },
    changeWebStatus() {
      //关闭或者开启官网网站
      this.$confirm(`确认${this.webStatus ? '打开' : '关闭'}网站？`, '重要提示！', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let params = {
          black: this.webStatus
        }
        patchApiData('get_all_config', params)
          .then(res => {
            this.getWebStatus()//刷新数据
            this.$message.success("操作成功！")
          })
      }).catch(() => {
        this.webStatus = !this.webStatus
      })
    },
    getStatsData() {
      this.loading = true
      getApiData('index_statistics', this.params)
        .then(res => {
          this.statsData = res
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleExport() {
      //24小时掉落
      window.open(`${api}export`)
    },
    gameRanking() {
      //对战排行导出
      window.open(`${api}export_battle`)
    },
    profitCache() {
      //利润缓存
      this.bottonLoading = true
      getApiData('index_cache', this.params)
        .then(res => {
          if (res.code === 0) {
            this.$message.success(res.message)
          } else if (res.code === 1) {
            this.$message.error(res.message)
          }
        })
        .finally(() => {
          this.bottonLoading = false
        })
    },
    exportKnapsack() {
      //导出背包
      window.open(`${api}backpack_export?start_time=${this.params.start_time}&end_time=${this.params.end_time}`)
    }
  }
}
</script>

<style type="scss">
.el-row {
  margin-bottom: 20px;
}

.el-col {
  border-radius: 4px;
}

.bg-purple-dark {
  background: #99a9bf;
}

.bg-purple {
  margin: 10px 0;
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
